import React from "react";
import { BrowserRouter } from "react-router-dom";
import AuthRoutes from "./AuthRoutes";
import AdminRoutes from "./AdminRouter";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <AuthRoutes />
      <AdminRoutes />
    </BrowserRouter>
  );
}

export default AppRouter;